export const listsFeatureExperimentName = 'expListsFeature';
export enum ListsFeatureExperimentVariantName {
	CONTROL = 'control',
	VARIANT = 'variant',
}
